"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _card = _interopRequireDefault(require("@amzn/meridian-tokens/component/card"));

var _cardHeader = _interopRequireDefault(require("./card-header"));

var _cardActionBar = _interopRequireDefault(require("./card-action-bar"));

var _image = _interopRequireDefault(require("../image"));

var _theme = require("../theme");

var _clickable = _interopRequireDefault(require("../_clickable"));

var _box = _interopRequireDefault(require("../box"));

var _floatingBox = _interopRequireDefault(require("../_floating-box"));

var _selectableCard = _interopRequireDefault(require("../_selectable-card"));

var _useFocus2 = _interopRequireDefault(require("../_use-focus"));

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _token = require("./../_utils/token");

var _focus = require("./../_utils/focus");

var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));

var _text = _interopRequireDefault(require("./../_styles/text"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var _borderRadius = _interopRequireDefault(require("./../_utils/border-radius"));

var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));

var _reducedMotionStyles = _interopRequireDefault(require("./../_styles/reduced-motion-styles"));

var _getInlinePadding = _interopRequireDefault(require("./../_utils/get-inline-padding"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isHeader = (0, _isElementOf["default"])(_cardHeader["default"]);
var isActionBar = (0, _isElementOf["default"])(_cardActionBar["default"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var imageSrc = _ref.imageSrc,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      pressed = _ref.pressed,
      spacingInset = _ref.spacingInset;
  var borderRadius = t("borderRadius");
  var imageBorderRadius = borderRadius - t("borderWidth");
  var padding = spacingInset ? (0, _getInlinePadding["default"])(spacingInset) : imageSrc ? {
    padding: "0 0 ".concat(t("spacingInset"), "px 0")
  } : {
    padding: "".concat(t("spacingInset"), "px 0")
  };
  return (0, _emotion.css)((0, _text["default"])(t), {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    // Use a container inside the clickable element so that we don't have to listen
    // for :hover on the same element that we transform vertically. Otherwise if you
    // transform the hovered element and it moves out from under your mouse then the
    // hover state will turn off and the element will bounce back.
    "&:hover > section": {
      transform: "translateY(".concat(t(pressed ? "offsetVerticalPressed" : "offsetVerticalHover"), "px)"),
      boxShadow: t.boxShadowCss(pressed ? "dropShadowPressed" : "dropShadowHover")
    },
    "& > section": _objectSpread(_objectSpread(_objectSpread({
      flex: "auto",
      display: "flex",
      flexDirection: "column",
      border: t.borderCss("border"),
      borderRadius: borderRadius
    }, padding), {}, {
      backgroundColor: t("backgroundColorDefault"),
      boxShadow: t.boxShadowCss("dropShadowDefault"),
      transition: "transform 0.1s ease, box-shadow 0.1s ease"
    }, _reducedMotionStyles["default"]), {}, {
      transform: "translateY(".concat(t("offsetVerticalDefault"), "px)")
    }),
    // Add horizontal padding to the header, contents, and action bar (but
    // not the image, which stretches the full width of the card)
    "& > section > *:not([role=img])": {
      // If a custom spacing inset has been declared, don't bother
      padding: spacingInset ? undefined : "0 ".concat(t("spacingInset"), "px")
    },
    // Add vertical rhythm to everything in the card
    "& > section > * + *": {
      marginTop: t("spacingVertical")
    },
    // Image styles
    "& > section > *[role=img]": {
      borderRadius: (0, _borderRadius["default"])(imageBorderRadius, ["topLeft", "topRight"]),
      overflow: "hidden"
    },
    // Children styles
    "& > section > *[mdn-card-children]": {
      flex: "auto"
    }
  });
}, ["imageSrc", "width", "minWidth", "maxWidth", "pressed", "spacingInset"]);
var nonInteractiveStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var width = _ref2.width,
      minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    backgroundColor: t("backgroundColorDefault")
  });
}, ["width", "minWidth", "maxWidth"]);
var focusStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var focus = _ref3.focus;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1,
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    dropShadow: t.boxShadowCss("dropShadowHover")
  }));
}, ["focus"]); //

var getFloatingBoxSpacingInset = function getFloatingBoxSpacingInset(_ref4) {
  var actionBar = _ref4.actionBar,
      header = _ref4.header;
  var spacingInsetTop = !header ? "500" : "none";
  var spacingInsetBottom = !actionBar ? "500" : "none";
  var spacingInsetHorizontal = "500";
  return "".concat(spacingInsetTop, " ").concat(spacingInsetHorizontal, " ").concat(spacingInsetBottom);
};
/**
 * Render an interactive element that contains content and actions about a
 * single subject and acts as an entry point to more detailed information.
 *
 * Cards always have a primary click action associated with them. If you want a
 * static container for related content, use the [Box](https://meridian.a2z.com/components/box/?platform=reactjs&previewTheme=blue-light)
 * component.
 */


var Card = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_card["default"], "card");

  var children = _react["default"].Children.toArray(props.children);

  var header = children.filter(isHeader)[0];
  var actionBar = children.filter(isActionBar)[0];
  var content = children.filter(function (child) {
    return !isHeader(child) && !isActionBar(child);
  });

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusDescendent = _useFocus.focusDescendent,
      focusProps = _useFocus.focusProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      pressed = _useState2[0],
      setPressed = _useState2[1];

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var onMouseDown = (0, _react.useCallback)(function (event) {
    // Determine if the mouse down action was directly on the card (or
    // alternately if the pressed action was on a separate focuseable element
    // within the card). If the former then we want to show the card in a
    // pressed state, if the latter then we don't (we'll assume the focuseable
    // element being pressed within the card has its own pressed state).
    var pressedDirectly = true;
    var node = event.target;

    while (pressedDirectly && node && !node.hasAttribute("mdn-card")) {
      if ((0, _focus.canFocusNode)(node)) {
        pressedDirectly = false;
      } else {
        node = node.parentNode;
      }
    }

    setPressed(pressedDirectly);
  }, []);
  var onMouseUpOrLeave = (0, _react.useCallback)(function () {
    return setPressed(false);
  }, []);
  return typeof props.checked === "undefined" && (props.href || props.onClick) ? /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
    "mdn-card": "",
    ref: ref,
    href: props.href,
    target: props.target,
    rel: props.rel,
    onClick: props.onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUpOrLeave,
    onMouseLeave: onMouseUpOrLeave,
    tabIndex: props.tabIndex,
    tag: props.tag,
    className: styles(t, _objectSpread(_objectSpread({}, props), {}, {
      pressed: pressed
    }))
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: focusStyles(t, {
      focus: focus && focusTrigger === "keyboard" && !focusDescendent
    })
  }, props.imageSrc ? /*#__PURE__*/_react["default"].createElement(_image["default"], {
    src: props.imageSrc,
    size: props.imageSize,
    viewportBackgroundColor: props.imageViewportBackgroundColor,
    viewportSpacingInset: props.imageViewportSpacingInset,
    viewportHeight: props.imageViewportHeight,
    viewportAspectRatio: props.imageViewportAspectRatio
  }, props.imageLabel) : null, header, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-card-children": ""
  }, content), actionBar)) : typeof props.checked !== "undefined" ? /*#__PURE__*/_react["default"].createElement(_selectableCard["default"], (0, _extends2["default"])({
    tag: "div",
    ref: ref,
    onChange: props.onClick,
    checked: props.checked,
    disabled: props.disabled,
    name: props.name,
    value: props.value
  }, props), props.children) : /*#__PURE__*/_react["default"].createElement(_floatingBox["default"], (0, _extends2["default"])({
    className: nonInteractiveStyles(t, _objectSpread({}, props)),
    tag: props.tag,
    ref: ref
  }, props), props.imageSrc ? /*#__PURE__*/_react["default"].createElement(_image["default"], {
    src: props.imageSrc,
    size: props.imageSize,
    viewportBackgroundColor: props.imageViewportBackgroundColor,
    viewportSpacingInset: props.imageViewportSpacingInset,
    viewportHeight: props.imageViewportHeight,
    viewportAspectRatio: props.imageViewportAspectRatio
  }, props.imageLabel) : null, header ? /*#__PURE__*/_react["default"].createElement(_box["default"], {
    spacingInset: "500 500 400 500"
  }, header) : null, /*#__PURE__*/_react["default"].createElement(_box["default"] // If a custom inset spacing is used, don't bother. Otherwise, bother.
  , {
    spacingInset: props.spacingInset ? undefined : getFloatingBoxSpacingInset({
      actionBar: actionBar,
      header: header
    })
  }, content), actionBar ? /*#__PURE__*/_react["default"].createElement(_box["default"], {
    spacingInset: "400 500 500 500"
  }, actionBar) : null);
});

Card.displayName = "Card";
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the card.
   *
   * If a `CardHeader` component is passed as a child it will automatically be
   * placed in the correct location near the top of the card. If a `CardActionBar`
   * component is passed as a child it will automatically be placed at the bottom
   * of the card. All other children will be placed in the main content area in
   * the middle of the card.
   *
   * Note that interactive elements are discouraged as children of the card because
   * the card itself is interactive. Any primary actions associated with the card
   * should be wrapped in the `CardActionBar` component.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The checked state of the card. Use this in conjunction with the
   * `onChange` prop to make the component interactive. Note: must be
   * initialized as either `true` or `false`.
   */
  checked: _propTypes["default"].bool,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * Used for Selectable card. This disables interaction with the component and applies
   * special visual styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link. Make sure you also
   * change the `tag` prop to `"a"` if you do!
   */
  href: _propTypes["default"].string,

  /**
   * An accessible label for the card's image. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  imageLabel: _propTypes["default"].string,

  /**
   * The size of the card's image. This should be a valid value for the
   * `background-size` CSS property.
   */
  imageSize: _propTypes["default"].string,

  /**
   * The source of the card's image. This is usually a URL, but any value that
   * is valid for the [src attribute of HTML's img tag](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-src)
   * is acceptable.
   */
  imageSrc: _propTypes["default"].string,

  /**
   * The aspect ratio of the viewport in which the card's image will be shown.
   *
   * This is ignored if `imageViewportHeight` is provided.
   */
  imageViewportAspectRatio: _propTypes["default"].number,

  /**
   * The background color of the viewport in which the card's image will be
   * shown. This may or may not be visible depending on the size, position, and
   * transparency of the image.
   */
  imageViewportBackgroundColor: _propTypes["default"].string,

  /**
   * This sets a fixed height on the viewport that contains the card's image.
   */
  imageViewportHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Apply padding around the card's image.
   */
  imageViewportSpacingInset: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the card using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the card using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   *
   * @since 6.2.0
   */
  rel: _propTypes["default"].string,

  /**
   * Apply custom padding around the card.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"100 none none none"` for 2px
   * padding on the top and 0px padding on the end, bottom, and starting sides).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * This allows you to specify the html tag used to render the card. This
   * defaults to `"div"`.
   */
  tag: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   *
   * @since 6.2.0
   */
  target: _propTypes["default"].string,

  /**
   * Used for selectable card. The value of the underlying input element.
   * This is used to populate the form data when submitting a form.
   * To change the on/off status of the component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * Set the width of the card using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   */
  onClick: _propTypes["default"].func
} : {};
Card.defaultProps = {
  imageViewportAspectRatio: 16 / 9,
  imageViewportSpacingInset: 0,
  tag: "div"
};
var _default = Card;
exports["default"] = _default;